<template>
  <a-form-item :label="label" name="entity" :required="required" :help="help">
    <a-select
      :getPopupContainer="triggerNode ? (triggerNode) => triggerNode.parentNode : null"
      v-model:value="selected"
      class="select"
      placeholder="Seleccionar empresa"
      :disabled="disabled"
      :mode="mode"
      :loading="loading"
    >
      <a-select-option
        v-if="showAllOption || allEntities"
        :disabled="blockAllEntities"
        :key="withOutEntities ? '' : defaultBehavior ? '' : 0"
      >
        <a-tooltip placement="right">
          <template #title v-if="blockAllEntities">
            Esta opción no está disponible mientras se listen “Todos los canales”.
          </template>
          Todas las empresas
        </a-tooltip>
      </a-select-option>

      <a-select-option
        v-for="item in entities"
        :key="item.id"
        :title="item.name"
        :disabled="forHubspotImport && !item.for_hubspot_import"
      >
        <a-tooltip>
          <template #title v-if="forHubspotImport && !item.for_hubspot_import">
            Esta empresa no tiene campañas con plantillas de contactos que tengan todas las columnas marcadas como Dato requerido homologadas con HubSpot.
          </template>
          <span>
            {{ item.name }}
          </span>
        </a-tooltip>
      </a-select-option>

      <a-select-option v-if="withOutEntities" :key="0"> Sin empresa </a-select-option>
    </a-select>
  </a-form-item>
</template>

<script>
import { fetchAllEntities } from "@/app/entities/services";

export default {
  props: {
    value: {
      required: true,
    },
    required: {
      required: false,
      type: Boolean,
      default: false,
    },
    label: {
      required: false,
      type: String,
      default: "",
    },
    help: {
      required: false,
      type: String,
      default: null,
    },
    blockAllEntities: {
      required: false,
      type: Boolean,
      default: false,
    },
    withOutEntities: {
      required: false,
      type: Boolean,
      default: false,
    },
    defaultBehavior: {
      type: Boolean,
      default: false,
    },
    showAll: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    includeItem: {
      required: false,
    },
    toSequence: {
      required: false,
      type: Boolean,
      default: false,
    },
    triggerNode: {
      required: false,
      type: Boolean,
      default: false,
    },
    mode: {
      required: false,
      type: String,
      default: null,
    },
    forHubspotImport: {
      required: false,
      type: Boolean,
      default: false,
    },
    allEntities: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      entities: [],
      loading: false,
    };
  },
  computed: {
    selected: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("update:value", value);
      },
    },
    showAllOption() {
      return this.showAll && this.$route.path !== "/reports/documents" && this.mode != 'multiple';
    },
  },
  async created() {
    await this.fetchEntities();
    this.$emit("finishLoading");
    if (this.includeItem) this.addItemEntity();
  },
  watch: {
    forHubspotImport(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.fetchEntities();
      }
    },
    includeItem(newVal) {
      if (newVal) this.addItemEntity();
    },
  },
  methods: {
    addItemEntity() {
      const index = this.entities.findIndex((el) => el.id == this.includeItem.id);
      if (index == -1) this.entities = [...this.entities, this.includeItem];
    },
    async fetchEntities() {
      this.loading = true;
      const data = await fetchAllEntities({ toUsersAssigned: this.toSequence, forHubspotImport: this.forHubspotImport });
      this.entities = data.results;
      this.loading = false;
    },
  },
};
</script>

<style lang="sass" scoped>
.select
  width: 100%

:deep(.ant-select-loading .ant-select-arrow-loading)
  left: 10px

:deep(.ant-select-loading .ant-select-selection-placeholder)
  margin-left: 15px !important

</style>
